import React from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal, Space } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

const { confirm } = Modal;

const showDeleteConfirm = (
  handleDelete = () => {},
  handleCancel = () => {},
  title = "Are you sure delete this task?",
  content = "",
  okText = "Yes",
  cancelText = "No"
) => {
  confirm({
    title: title,
    icon: <ExclamationCircleFilled />,
    content: content,
    okText: okText,
    okType: "danger",
    cancelText: cancelText,
    onOk() {
      handleDelete();
    },
    onCancel() {
      handleCancel();
    },
  });
};
const DeleteModal = ({
  handleDelete = () => {},
  handleCancel = () => {},
  title = "Are you sure delete this task?",
  content = "",
  okText = "Yes",
  cancelText = "No",
}) => (
  <Space wrap>
    <DeleteOutlined
      className="icons_style"
      onClick={(e) => {
        e.stopPropagation();
        showDeleteConfirm(handleDelete, handleCancel, title, content);
      }}
    />
  </Space>
);
export default DeleteModal;
